import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';



//const ENDPOINTS = "http://localhost:8090";//local
//const ENDPOINTSjava = "http://localhost:8090";//local

const ENDPOINTS = "https://api.athidhidevo.com";//local
const ENDPOINTSjava = "https://api.athidhidevo.com";


//const ENDPOINTS = "http://203.95.216.135:3000";//local
//const ENDPOINTSjava = "http://203.95.216.135:3000";//local

export class webconfig
{
  getconnection() {
    return ENDPOINTS;

  }
  getconnectionjava() {

    return ENDPOINTSjava;

  }
}
